import type {FilterCreator, Listener, Filter} from './types';
import {callFirstMatch} from './combinators';
import {preventDefault} from './sideEffects';
import {getCharacterCount} from '@packages/utilities/string-utils';

// we return true if the event matches the test to signal
// to callFirstMatch that it should exit early
export const onMatch: FilterCreator =
  (test) => (callback: Listener) => (event) => {
    if (typeof callback === 'function' && test(event)) {
      callback(event);
      return true;
    }
  };

export const onKeys = (...matches: Array<string>): Filter =>
  // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
  onMatch((event) => matches.includes(event.key));

export const onA: Filter = onKeys('A', 'a');
export const onB: Filter = onKeys('B', 'b');
export const onC: Filter = onKeys('C', 'c');
export const onD: Filter = onKeys('D', 'd');
export const onE: Filter = onKeys('E', 'e');
export const onF: Filter = onKeys('F', 'f');
export const onG: Filter = onKeys('G', 'g');
export const onH: Filter = onKeys('H', 'h');
export const onI: Filter = onKeys('I', 'i');
export const onJ: Filter = onKeys('J', 'j');
export const onK: Filter = onKeys('K', 'k');
export const onL: Filter = onKeys('L', 'l');
export const onM: Filter = onKeys('M', 'm');
export const onN: Filter = onKeys('N', 'n');
export const onO: Filter = onKeys('O', 'o');
export const onP: Filter = onKeys('P', 'p');
export const onQ: Filter = onKeys('Q', 'q');
export const onR: Filter = onKeys('R', 'r');
export const onS: Filter = onKeys('S', 's');
export const onT: Filter = onKeys('T', 't');
export const onU: Filter = onKeys('U', 'u');
export const onV: Filter = onKeys('V', 'v');
export const onW: Filter = onKeys('W', 'w');
export const onX: Filter = onKeys('X', 'x');
export const onY: Filter = onKeys('Y', 'y');
export const onZ: Filter = onKeys('Z', 'z');

export const onArrowDown: Filter = onKeys('ArrowDown');
export const onArrowLeft: Filter = onKeys('ArrowLeft');
export const onArrowRight: Filter = onKeys('ArrowRight');
export const onArrowUp: Filter = onKeys('ArrowUp');
export const onBackspace: Filter = onKeys('Backspace');
export const __DEPRECATED__onButtonConfirm: Filter = onKeys(
  'Enter',
  ' ',
  'Spacebar'
);
export const onComma: Filter = onKeys(',');
export const onEnter: Filter = onKeys('Enter');
export const onEscape: Filter = onKeys('Escape');
export const onSpace: Filter = onKeys(' ', 'Spacebar');
export const onTab: Filter = onKeys('Tab');

// this includes the ctrl key but also all other hardware keys that do not
// produce a printable character
// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
const isControlCharacter = (event) => getCharacterCount(event.key) !== 1;

export const onControlCharacter: Filter = onMatch(isControlCharacter);
export const onPrintableCharacter: Filter = onMatch(
  (event) => !isControlCharacter(event)
);

export const onDown = onArrowDown;
export const onLeft = onArrowLeft;
export const onRight = onArrowRight;
export const onUp = onArrowUp;
const noop = () => {};
const preventDefaultOnSpace = onSpace(preventDefault(noop));
export const onButtonKeyDown = (cb: Listener): Listener =>
  callFirstMatch(onEnter(cb), preventDefaultOnSpace);
export const onButtonKeyUp = onSpace;

export const onButtonConfirm = (
  cb: Listener
): {
  onKeyDown: Listener;
  onKeyUp: Listener;
} => ({
  onKeyDown: onButtonKeyDown(cb),
  onKeyUp: onButtonKeyUp(cb),
});
